/**
 * Build Your Own Bundle picker: tracks how many patterns are selected,
 * blocks "Add to cart" until exactly the required count is chosen, filters
 * the grid by category, and serializes the selection into line item
 * properties on submit.
 */
function initBuildYourOwnBundlePicker(root) {
  const requiredCount = Number(root.dataset.requiredCount) || 0;
  const statusCount = root.querySelector('[data-byob-selected-count]');
  const checkboxes = /** @type {HTMLInputElement[]} */ ([...root.querySelectorAll('.byob-picker__checkbox')]);
  const submitButton = /** @type {HTMLButtonElement} */ (root.querySelector('[data-byob-submit]'));
  const propertiesContainer = root.querySelector('[data-byob-properties]');
  const form = /** @type {HTMLFormElement} */ (root.querySelector('[data-byob-form]'));
  const filterButtons = [...root.querySelectorAll('[data-byob-filter]')];
  const cards = [...root.querySelectorAll('.byob-picker__card')];

  // A pattern set fills 2 of the picks (data-byob-weight = custom.pick_weight).
  const weightOf = (checkbox) => Number(checkbox.dataset.byobWeight) || 1;

  function updateCount() {
    const selected = checkboxes.filter((checkbox) => checkbox.checked);
    const total = selected.reduce((sum, checkbox) => sum + weightOf(checkbox), 0);
    if (statusCount) statusCount.textContent = String(total);

    submitButton.disabled = total !== requiredCount;

    // Never overshoot: an unchecked box is disabled when it would push the
    // weighted total past the required count (a set can't fit into 1 slot left).
    checkboxes.forEach((checkbox) => {
      if (!checkbox.checked) checkbox.disabled = total + weightOf(checkbox) > requiredCount;
    });
  }

  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', updateCount);
  });

  filterButtons.forEach((button) => {
    button.addEventListener('click', () => {
      filterButtons.forEach((other) => other.classList.toggle('is-active', other === button));
      const filter = button.getAttribute('data-byob-filter');
      cards.forEach((card) => {
        // Patterns the signed-in buyer already owns stay hidden (assets/owned-patterns.js).
        if (card.hasAttribute('data-byob-owned')) {
          card.hidden = true;
          return;
        }
        if (filter === 'all') {
          card.hidden = false;
          return;
        }
        const categories = (card.getAttribute('data-byob-category') || '').split(',');
        card.hidden = !categories.includes(filter);
      });
    });
  });

  form?.addEventListener('submit', () => {
    const selected = checkboxes.filter((checkbox) => checkbox.checked);
    if (propertiesContainer) propertiesContainer.innerHTML = '';
    selected.forEach((checkbox, index) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[Pattern ${index + 1}]`;
      input.value = `${checkbox.dataset.byobTitle} (Product ID: ${checkbox.value})`;
      propertiesContainer?.appendChild(input);
    });

    // Hidden, machine-readable (Shopify hides "_"-prefixed properties from the
    // customer-facing cart) — this is what the Paddle checkout and the Worker's
    // webhook resolver read to know exactly which patterns were chosen.
    const hidden = document.createElement('input');
    hidden.type = 'hidden';
    hidden.name = 'properties[_build_your_own]';
    hidden.value = JSON.stringify(selected.map((checkbox) => checkbox.value));
    propertiesContainer?.appendChild(hidden);
  });

  updateCount();
}

document.querySelectorAll('.byob-picker').forEach((root) => {
  if (root instanceof HTMLElement) initBuildYourOwnBundlePicker(root);
});
